import apiClientInstaller from './installer';

function ApiClient() {
    return apiClientInstaller({ extendResponse: true });
}

export default ApiClient();
